import { defineCollection } from "@rebasepro/cms-types";
import { files } from "../resources";

// The AI host's recorded lines and written comments (songbuzz_voice_cache), so a line is paid for once. `comment:`
// keys are comments (kept 30 days, no audio), the rest are speech (180 days unless kept), their WAV in the bucket
// under voice/. backend/src/voice-store.ts reads and writes it.
const voiceCacheCollection = defineCollection({
    name: "Voice cache",
    singularName: "Voice line",
    slug: "voice_cache",
    table: "songbuzz_voice_cache",
    description: "Lines the AI host has already spoken or written, kept so each is paid for once.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operations: ["update", "delete"], roles: ["admin"] },
    ],
    properties: {
        // a hash of the line, its voice and style (comments: "comment:" and the prompt's hash)
        key: { name: "Key", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        text: { name: "What the host says", type: "string", admin: { readOnly: true, multiline: true } },
        keep: { name: "Keep forever", description: "Off: deleted 180 days after it was recorded (a comment, 30 days)", type: "boolean", defaultValue: false, validation: { required: true } },
        audio: { name: "Audio", type: "string", storage: { storageSource: files, storagePath: "voice", acceptedFiles: ["audio/*"] }, admin: { readOnly: true } },
        // Where the audio lived before the bucket. Emptied once copied (voice-store.ts), dropped when every row is.
        // Admin-only rather than excludeFromApi, which hides it from rebase.dataAsAdmin too, and the copy has to read it.
        wav: { name: "Audio (old)", type: "binary", access: { read: ["admin"], write: [] }, admin: { hideFromCollection: true, disabled: { hidden: true } } },
        createdAt: { name: "Recorded", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "AudioLines",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["createdAt", "desc"],
        display: {
            title: ({ entity }) => entity.values.text ? String(entity.values.text).slice(0, 120) : "No text",
            subtitle: ({ entity }) => [String(entity.values.key ?? "").startsWith("comment:") ? "Written comment" : "Spoken line", entity.values.keep ? "kept forever" : ""].filter(Boolean).join(" · "),
            date: "createdAt",
        },
        form: {
            sections: [
                { key: "line", properties: ["text", "audio", "keep", "createdAt"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["key"] },
            ],
        },
    },
});

export default voiceCacheCollection;
